import React from 'react'

const DashboardStorePage: React.FC = () => {
  return (
    <div style={{width: '100%', height: '100vh', backgroundColor: '#fcfcfc'}}>
      <iframe
        title='Dashboard Store'
        src='/dashboard-store/index.html'
        style={{width: '100%', height: '100%', border: 0, display: 'block'}}
      />
    </div>
  )
}

export default DashboardStorePage
